import React from "react";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import ArtifactView from "components/LanguageModelArtifact/ArtifactView";

class ArtifactViewContainer extends React.Component {
  render() {
    return <ArtifactView />;
  }
}

export default compose(withRouter)(ArtifactViewContainer);
